<template>
    <b-card
        no-body
        :border-variant="borderVariant"
        class="supplier-verification-instruction"
    >
        <div class="card-header">
            <b-card-title>{{ title }}</b-card-title>
            <b-button
                v-if="isSupplierInstructionRemovable"
                class="btn-icon btn-sm"
                variant="danger"
                @click="$emit('remove-supplier', supplierInstruction)"
            >
                <feather-icon icon="MinusIcon" />
            </b-button>
        </div>
        <div class="pt-1 px-2 pb-2">
            <b-form-group
                class="mb-1"
                :label="$t('Component(Label):description')"
            >
                <b-form-textarea
                    :value="supplierInstruction.description"
                    :placeholder="$t('Component(Placeholder):type-here')"
                    rows="3"
                    max-rows="8"
                    @input="changeDescription"
                />
            </b-form-group>
            <b-form-group
                v-if="allowFile"
                :label="$t('Component(File):upload-file')"
            >
                <b-form-file
                    v-model="supplierInstruction.document"
                    accept="application/pdf,application/x-pdf"
                    @input="emitChange"
                />
                <div
                    v-if="supplierInstruction.file && supplierInstruction.file.name"
                    class="mt-50"
                >
                    {{ supplierInstruction.file.name }}
                    <b-button
                        class="btn-icon btn-sm ml-50"
                        variant="primary"
                        @click="$emit('preview-supplier', supplierInstruction)"
                    >
                        <feather-icon icon="EyeIcon" />
                    </b-button>
                    <b-button
                        class="btn-icon btn-sm ml-50"
                        variant="primary"
                        @click="$emit('download-supplier', supplierInstruction)"
                    >
                        <feather-icon icon="DownloadCloudIcon" />
                    </b-button>
                </div>
            </b-form-group>

            <div
                v-if="replyInstruction"
                class="border-top pt-1 mt-1"
            >
                <SupplierVerificationSourceBadge source="reply" />
                <p
                    v-if="replyInstruction.description"
                    class="mt-1 mb-50"
                >
                    {{ replyInstruction.description }}
                </p>
                <div v-if="replyInstruction.file">
                    {{ replyInstruction.file.name }}
                    <b-button
                        class="btn-icon btn-sm ml-50"
                        variant="primary"
                        @click="$emit('preview-reply', replyInstruction)"
                    >
                        <feather-icon icon="EyeIcon" />
                    </b-button>
                    <b-button
                        class="btn-icon btn-sm ml-50"
                        variant="primary"
                        @click="$emit('download-reply', replyInstruction)"
                    >
                        <feather-icon icon="DownloadCloudIcon" />
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import {
    BButton, BCard, BCardTitle, BFormFile, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import SupplierVerificationSourceBadge from './SupplierVerificationSourceBadge.vue'

export default {
    components: {
        BButton,
        BCard,
        BCardTitle,
        BFormFile,
        BFormGroup,
        BFormTextarea,
        SupplierVerificationSourceBadge,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        supplierInstruction: {
            type: Object,
            required: true,
        },
        replyInstruction: {
            type: Object,
            default: null,
        },
        allowFile: {
            type: Boolean,
            default: true,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: 'default',
            validator(value) {
                return ['default', 'supplier'].includes(value)
            },
        },
    },
    computed: {
        borderVariant() {
            return this.theme === 'supplier' ? 'primary' : 'light'
        },
        isSupplierInstructionRemovable() {
            return this.removable && !!(
                this.supplierInstruction.id
                || this.supplierInstruction.document
                || (this.supplierInstruction.file && this.supplierInstruction.file.name)
            )
        },
    },
    methods: {
        changeDescription(description) {
            this.supplierInstruction.description = description
            this.emitChange()
        },
        emitChange() {
            this.$emit('change', this.supplierInstruction)
        },
    },
}
</script>
